import { Locales } from '@vue-pdf-viewer/viewer';

export const PDF_VIEWER_LOCALIZATIONS = {
  de_DE: {
    // This component does not use library internal tooltips, thus only printer messages need to be overridden
    ...Locales.en_US, // fallback for missing keys

    // --- Search ---
    searchButtonTooltip: 'Suchen',
    searchInputPlaceholder: 'Im Dokument suchen…',
    searchInputTooltip: 'Suchbegriff eingeben',
    searchPrevTooltip: 'Vorheriges Ergebnis',
    searchNextTooltip: 'Nächstes Ergebnis',
    searchCloseButtonTooltip: 'Suche schließen',
    searchMatchCaseLabel: 'Groß-/Kleinschreibung',
    searchMatchCaseTooltip: 'Groß-/Kleinschreibung beachten',
    searchWholeWordsLabel: 'Ganzes Wort',
    searchWholeWordsTooltip: 'Nur ganze Wörter',

    // --- Navigation ---
    previousPageTooltip: 'Vorherige Seite',
    currentPageTooltip: 'Aktuelle Seite',
    nextPageTooltip: 'Nächste Seite',
    firstPageLabel: 'Erste Seite',
    firstPageTooltip: 'Zur ersten Seite',
    lastPageLabel: 'Letzte Seite',
    lastPageTooltip: 'Zur letzten Seite',

    // --- Zoom ---
    zoomOutTooltip: 'Verkleinern',
    zoomInTooltip: 'Vergrößern',
    zoomSelectTooltip: 'Zoomstufe',
    zoomActualSize: 'Tatsächliche Größe',
    zoomPageFit: 'An Seite anpassen',
    zoomPageWidth: 'An Breite anpassen',

    // --- Theme ---
    themeEnableDarkTooltip: 'Dunkles Design aktivieren',
    themeEnableLightTooltip: 'Helles Design aktivieren',

    // --- File ---
    openLocalFileLabel: 'Datei öffnen',
    openLocalFileTooltip: 'Lokale PDF-Datei öffnen',
    downloadFileLabel: 'Herunterladen',
    downloadFileTooltip: 'PDF herunterladen',

    // --- Comment / Anmerkungen ---
    commentPanelTooltip: 'Kommentarbereich ein-/ausblenden',
    commentPanelLabel: 'Kommentare',
    commentPageSuffix: 'Seite',
    commentPagePrefix: 'auf',
    commentLabel: 'Kommentar',
    commentHideTooltip: 'Kommentare ausblenden',

    // --- Print ---
    printLabel: 'Drucken',
    printTooltip: 'PDF drucken',
    printLoadingMessage: 'Dokument wird vorbereitet…',
    printCancelLabel: 'Abbrechen',

    // --- Fullscreen ---
    fullScreenLabel: 'Vollbild',
    fullScreenTooltip: 'Vollbildmodus umschalten',

    // --- More Options ---
    moreOptionTooltip: 'Weitere Optionen',

    // --- Rotation ---
    rotateClockwiseLabel: 'Im Uhrzeigersinn drehen',
    rotateClockwiseTooltip: 'PDF um 90° im Uhrzeigersinn drehen',
    rotateCounterclockwiseLabel: 'Gegen Uhrzeigersinn drehen',
    rotateCounterclockwiseTooltip: 'PDF um 90° gegen den Uhrzeigersinn drehen',

    // --- Tools ---
    textSelectionLabel: 'Textauswahl',
    textSelectionTooltip: 'Textauswahl-Werkzeug aktivieren',
    handToolLabel: 'Handwerkzeug',
    handToolTooltip: 'Hand-Werkzeug aktivieren (Verschieben)',

    // --- PageView ---
    pageScrollingLabel: 'Seitenweise',
    pageScrollingTooltip: 'Seitenweise scrollen',
    verticalScrollingLabel: 'Vertikal',
    verticalScrollingTooltip: 'Vertikales Scrollen',
    horizontalLabel: 'Horizontal',
    horizontalTooltip: 'Horizontales Scrollen',
    wrappedScrollingLabel: 'Umbruch',
    wrappedScrollingTooltip: 'Umbruch-Scrollen',
    singlePageLabel: 'Einzelne Seite',
    singlePageTooltip: 'Einzelne Seite anzeigen',
    dualPageLabel: 'Doppelseite',
    dualPageTooltip: 'Doppelseiten anzeigen',
    dualPageWithCoverLabel: 'Doppelseite mit Deckblatt',
    dualPageWithCoverTooltip: 'Doppelseiten mit Deckblatt anzeigen',

    // --- Document Settings ---
    documentPropertiesLabel: 'Dokumenteigenschaften',
    documentPropertiesTooltip: 'Eigenschaften anzeigen',
    propertiesFilenameLabel: 'Dateiname',
    propertiesFileSizeLabel: 'Dateigröße',
    propertiesTitleLabel: 'Titel',
    propertiesAuthorLabel: 'Autor',
    propertiesSubjectLabel: 'Betreff',
    propertiesKeywordLabel: 'Schlagwörter',
    propertiesCreatorLabel: 'Ersteller',
    propertiesCreateOnLabel: 'Erstellungsdatum',
    propertiesModifiedOnLabel: 'Änderungsdatum',
    propertiesPDFProducerLabel: 'PDF-Produzent',
    propertiesPDFVersionLabel: 'PDF-Version',
    propertiesPageCountLabel: 'Seitenanzahl',

    // --- Thumbnails ---
    thumbnailTooltip: 'Miniaturansichten',

    // --- Password ---
    passwordModalTitle: 'Passwort erforderlich',
    passwordModalMessage: 'Dieses Dokument ist passwortgeschützt. Bitte geben Sie das Passwort ein.',
    passwordPlaceholder: 'Passwort eingeben',
    passwordConfirmLabel: 'Öffnen',
    passwordError: 'Falsches Passwort. Bitte versuchen Sie es erneut.',

    // --- Drag & Drop ---
    dragDropFileMessage: 'PDF-Datei hier ablegen',

    // --- Annotationen (allgemein) ---
    annotationLabel: 'Anmerkungen',
    annotationToggleShowTooltip: 'Anmerkungen anzeigen',
    annotationToggleHideTooltip: 'Anmerkungen ausblenden',
    annotationTextSelectionLabel: 'Textauswahl',
    annotationTextSelectionTooltip: 'Text auswählen für Anmerkungen',

    // --- Highlights ---
    annotationHighlightLabel: 'Hervorheben',
    annotationHighlightTooltip: 'Text hervorheben',
    annotationHighlightColorTooltip: 'Farbe für Hervorhebung',
    annotationHighlightColorPickerLabel: 'Hervorhebungsfarbe wählen',
    annotationHighlightDeleteTooltip: 'Hervorhebung löschen',

    // --- Underlines ---
    annotationUnderlineLabel: 'Unterstreichen',
    annotationUnderlineTooltip: 'Text unterstreichen',
    annotationUnderlineColorTooltip: 'Farbe für Unterstreichung',
    annotationUnderlineColorPickerLabel: 'Unterstreichungsfarbe wählen',
    annotationUnderlineDeleteTooltip: 'Unterstreichung löschen',

    // --- Strikethrough ---
    annotationStrikethroughLabel: 'Durchstreichen',
    annotationStrikethroughTooltip: 'Text durchstreichen',
    annotationStrikethroughColorTooltip: 'Farbe für Durchstreichung',
    annotationStrikethroughColorPickerLabel: 'Durchstreichfarbe wählen',
    annotationStrikethroughDeleteTooltip: 'Durchstreichung löschen',

    // --- FreeText ---
    annotationFreeTextLabel: 'Freitext',
    annotationFreeTextTooltip: 'Freitext-Anmerkung hinzufügen',
    annotationFreeTextDeleteTooltip: 'Freitext-Anmerkung löschen',
    annotationFreeTextTextStyleLabel: 'Textstil',
    annotationFreeTextTextStyleTooltip: 'Textstil für Freitext',
    annotationFreeTextFontColorLabel: 'Schriftfarbe',
    annotationFreeTextTextSizeTooltip: 'Schriftgröße',
    annotationFreeTextTextSizeLabel: 'Schriftgröße',
    annotationFreeTextTextSizePlaceholder: 'z.B. 12',

    // --- Signature ---
    annotationSignatureLabel: 'Signatur',
    annotationSignatureTooltip: 'Signatur hinzufügen',
    annotationSignatureAddLabel: 'Signatur erstellen',
    annotationSignatureAddTooltip: 'Neue Signatur hinzufügen',

    // --- Comment-Annotation ---
    annotationCommentLabel: 'Kommentar',
    annotationCommentTooltip: 'Kommentar-Anmerkung hinzufügen',

    // --- Image-Annotation ---
    annotationImageLabel: 'Bild',
    annotationImageTooltip: 'Bild einfügen',
    annotationImageUnsupportedFileMessage: 'Nicht unterstütztes Dateiformat. Bitte wählen Sie ein Bild.',
    annotationImageUnsupportedFileSizeMessage: 'Datei zu groß. Maximale Größe: 5 MB.',
    annotationImageDeleteTooltip: 'Bild-Anmerkung löschen',
  },
  en_US: Locales.en_US,
};
